import React from 'react'
import styled from 'styled-components'

import AditionalServicesV2 from 'components/AditionalServicesV2'
import GhostRadioV2 from 'components/GhostRadioV2'
import { generateMediaUrl } from 'utils'
import { PAGE_URL } from 'config'

import IcCheck from '../images/ic-check.component.svg'

const Revision = (props) => {
  const {
    loading,
    tab,
    currentTariff,
    tariffInfo,
    electricityPriceList,
    prices,
    gasPriceList,
    renderBtns,
    formValues,
    changeField,
    allowDataSharing,
    districts,
    municipalities,
    billingMunicipalities,
  } = props

  const gasStage = currentTariff.result.gasStage
  const timeCycle = currentTariff.result.priceListTimeCycle
  const calculatedHiredPowerFactor =
    currentTariff.result.calculatedHiredPowerFactor

  const _renderRow = (field, name, isImg = false, suffix = '') => {
    let fieldToUse = field
    if (isImg) {
      fieldToUse = <img src={generateMediaUrl(field)} alt={name} />
    }

    return field ? (
      <Row hasImg={isImg}>
        <InvoiceCell light={true}>{name}</InvoiceCell>
        {isImg ? (
          <InvoiceCell>{fieldToUse}</InvoiceCell>
        ) : (
          <InvoiceCell>{`${fieldToUse} ${suffix}`}</InvoiceCell>
        )}
      </Row>
    ) : null
  }

  const _renderDistrictRow = (field, name) => {
    if (field) {
      let fieldLabel = districts.find(({ value }) => value === field).label

      return (
        <Row>
          <InvoiceCell light={true}>{name}</InvoiceCell>
          <InvoiceCell>{fieldLabel}</InvoiceCell>
        </Row>
      )
    }

    return null
  }

  const _renderMunicipalitiesRow = (field, name, billing) => {
    if (field) {
      const correctMunicipalities = billing
        ? billingMunicipalities
        : municipalities

      let fieldLabel = correctMunicipalities.find(
        ({ value }) => value === field
      ).label

      return (
        <Row>
          <InvoiceCell light={true}>{name}</InvoiceCell>
          <InvoiceCell>{fieldLabel}</InvoiceCell>
        </Row>
      )
    }

    return null
  }

  const _renderSpan = (label, value, suffix) => {
    return (
      value && (
        <span>
          <p>{label}</p>
          <p>
            <b>{value}</b> {suffix}
          </p>
        </span>
      )
    )
  }

  const _renderElectricityRow = () => {
    return (
      electricityPriceList &&
      prices.electricity && (
        <Row isEnergy>
          <InvoiceCell light={true}>Eletricidade</InvoiceCell>
          <EnergyCell>
            {_renderSpan(
              'Termo Potência',
              prices.electricity.termo_fixo,
              '€/Dia'
            )}
            <span>
              <p>Energia</p>
              <p></p>
            </span>
            {_renderSpan('Fora do Vazio', prices.electricity.cheia, '€/kWh')}
            {_renderSpan('Vazio', prices.electricity.vazio, '€/kWh')}
          </EnergyCell>
        </Row>
      )
    )
  }

  const _renderGasRow = () => {
    return (
      gasPriceList &&
      prices.gas && (
        <Row isEnergy>
          <InvoiceCell light={true}>Gás Natural</InvoiceCell>
          <EnergyCell>
            {_renderSpan('Energia', prices.gas.termo_energia, '€/kWh')}
            {_renderSpan('Termo Fixo', prices.gas.termo_fixo, '€/Dia')}
          </EnergyCell>
        </Row>
      )
    )
  }

  const isEleContract = tariffInfo.pricelistadditionalinfo.electronic_contract
  const timeCycleValue =
    timeCycle === 's'
      ? 'Simples'
      : timeCycle === 'b'
      ? 'Bi-Horário'
      : timeCycle === 't'
      ? 'Tri-Horário'
      : null
  const contactValue = formValues.personal.contact.value
  const contactMethod =
    contactValue === 'email'
      ? 'E-mail'
      : contactValue === 'phone'
      ? 'Chamada telefónica'
      : 'SMS'
  const debitDirection = formValues.billing.directDebit.value ? 'Sim' : 'Não'
  const billingAddressValue = formValues.billing.billingAddress.value === 'd'
  const billingAddress = billingAddressValue
    ? 'Diferente da morada do contrato'
    : 'Igual à morada de contrato'

  return (
    !loading &&
    tab === 'revision' && (
      <Wrapper>
        <div className='tableWrapper'>
          <Table>
            <tbody>
              <Row>
                <TitleCell>Resumo do Tarifário</TitleCell>
              </Row>
              {tariffInfo &&
                _renderRow(tariffInfo.entity.hi_res_logo, 'Fornecedor', true)}
              {tariffInfo && _renderRow(tariffInfo.designation, 'Tarifário')}
              {_renderElectricityRow()}
              {_renderGasRow()}
              {tariffInfo && (
                <AditionalServicesV2 list={tariffInfo.additional_services} />
              )}

              {currentTariff && currentTariff.result.electricityPriceList && (
                <Row>
                  <TitleCell>Eletricidade</TitleCell>
                </Row>
              )}
              {currentTariff && currentTariff.result.electricityPriceList
                ? _renderRow(
                    currentTariff.result.prices.electricity.termo_fixo,
                    'Termo Potência',
                    false,
                    '€/Dia'
                  )
                : null}
              {currentTariff &&
              currentTariff.result.electricityPriceList &&
              timeCycle === 's'
                ? _renderRow(
                    currentTariff.result.prices.electricity.cheia,
                    'Energia',
                    false,
                    '€/kWh'
                  )
                : null}
              {currentTariff &&
              currentTariff.result.electricityPriceList &&
              timeCycle !== 's'
                ? _renderRow(
                    currentTariff.result.prices.electricity.vazio,
                    'Vazio',
                    false,
                    '€/kWh'
                  )
                : null}
              {currentTariff &&
              currentTariff.result.electricityPriceList &&
              timeCycle === 'b'
                ? _renderRow(
                    currentTariff.result.prices.electricity.cheia,
                    'Fora do Vazio',
                    false,
                    '€/kWh'
                  )
                : null}
              {currentTariff &&
              currentTariff.result.electricityPriceList &&
              timeCycle !== 's' &&
              timeCycle !== 'b'
                ? _renderRow(
                    currentTariff.result.prices.electricity.ponta,
                    'Ponta',
                    false,
                    '€/kWh'
                  )
                : null}
              {currentTariff &&
              currentTariff.result.electricityPriceList &&
              timeCycle !== 's' &&
              timeCycle !== 'b'
                ? _renderRow(
                    currentTariff.result.prices.electricity.cheia,
                    'Cheias',
                    false,
                    '€/kWh'
                  )
                : null}

              {currentTariff &&
              currentTariff.result.electricityPriceList &&
              calculatedHiredPowerFactor ? (
                <Row>
                  <InvoiceCell light={true}>Potência</InvoiceCell>
                  <InvoiceCell>
                    {Math.round(calculatedHiredPowerFactor * 1e2) / 1e2} kVa
                  </InvoiceCell>
                </Row>
              ) : null}
              {currentTariff && currentTariff.result.electricityPriceList
                ? _renderRow(timeCycleValue, 'Tarifa')
                : null}
              {currentTariff && currentTariff.result.electricityPriceList
                ? _renderRow('Diário', 'Ciclo Horário')
                : null}

              {currentTariff && currentTariff.result.gasPriceList && (
                <Row>
                  <TitleCell>Gás Natural</TitleCell>
                </Row>
              )}

              {gasStage && currentTariff.result.gasPriceList ? (
                <Row>
                  <InvoiceCell light={true}>Escalão</InvoiceCell>
                  <InvoiceCell>Escalão {gasStage}</InvoiceCell>
                </Row>
              ) : null}
              {currentTariff.result.gasPriceList &&
                _renderRow(
                  currentTariff.result.prices.gas.termo_fixo,
                  'Termo Fixo',
                  false,
                  '€/Dia'
                )}
              {currentTariff.result.gasPriceList &&
                _renderRow(
                  currentTariff.result.prices.gas.termo_energia,
                  'Energia',
                  false,
                  '€/kWh'
                )}
              <Row>
                <TitleCell>Dados de adesão ao tarifário</TitleCell>
              </Row>
              {_renderRow(formValues.personal.name.value, 'Primeiro nome')}
              {_renderRow(formValues.personal.surName.value, 'Apelido')}
              {_renderRow(formValues.personal.nif.value, 'NIF')}
              {_renderRow(
                formValues.personal.phone.value,
                'Telefone/Telemóvel'
              )}
              {_renderRow(contactMethod, 'Meio de contato preferencial')}
              {_renderRow(debitDirection, 'Débito direto')}
              {_renderRow('Sim', 'Fatura eletrónica')}
              {_renderRow(billingAddress, 'Morada de faturação')}

              {!isEleContract && (
                <Row>
                  <TitleCell>
                    {formValues.billing.billingAddress.value === 'e'
                      ? 'Morada de Contrato e Faturação'
                      : 'Morada de Contrato'}
                  </TitleCell>
                </Row>
              )}
              {!isEleContract &&
                _renderRow(formValues.billing.street.value, 'Rua')}
              {!isEleContract &&
                _renderRow(formValues.billing.door.value, 'Nº da Porta')}
              {!isEleContract &&
                _renderRow(formValues.billing.floor.value, 'Andar')}
              {!isEleContract &&
                _renderDistrictRow(
                  formValues.billing.district.value,
                  'Distrito'
                )}
              {!isEleContract &&
                _renderMunicipalitiesRow(
                  formValues.billing.municipality.value,
                  'Concelho'
                )}

              {!isEleContract && billingAddressValue && (
                <Row>
                  <TitleCell>Morada De Faturação</TitleCell>
                </Row>
              )}
              {!isEleContract &&
                billingAddressValue &&
                _renderRow(formValues.billing.billingStreet.value, 'Rua')}
              {!isEleContract &&
                billingAddressValue &&
                _renderRow(formValues.billing.billingDoor.value, 'Nº da Porta')}
              {!isEleContract &&
                billingAddressValue &&
                _renderRow(formValues.billing.billingFloor.value, 'Andar')}
              {!isEleContract &&
                billingAddressValue &&
                _renderDistrictRow(
                  formValues.billing.billingDistrict.value,
                  'Distrito'
                )}
              {!isEleContract &&
                billingAddressValue &&
                _renderMunicipalitiesRow(
                  formValues.billing.billingMunicipality.value,
                  'Concelho',
                  true
                )}

              <Row>
                <TitleCell>Outras Informações</TitleCell>
              </Row>
              <ListRow>
                <div className='item'>
                  <IcCheck />
                  <p>
                    {' '}
                    Os valores apresentados baseiam-se nos dados introduzidos e
                    representam uma estimativa da sua fatura de energia nos
                    próximos 12 meses e da poupança expectável face ao seu
                    tarifário atual.
                  </p>
                </div>
                <div className='item'>
                  <IcCheck />
                  <p>
                    {' '}
                    Estes valores têm em consideração as condições de consumo de
                    eletricidade e/ou gás natural inseridos e que se assumem
                    corretos e atuais.{' '}
                  </p>
                </div>
                <div className='item'>
                  <IcCheck />
                  <p>
                    {' '}
                    O presente pedido de adesão não constitui uma proposta
                    contratual, sendo esta uma responsabilidade do
                    comercializador, que entrará em contacto consigo.{' '}
                  </p>
                </div>
                <div className='item'>
                  <IcCheck />
                  <p>
                    {' '}
                    O OLMC não pode ser responsabilizado por eventuais
                    diferenças no valor de faturação e/ou consumos de
                    eletricidade e gás natural que venham a ocorrer durante este
                    período,. nem por eventuais divergências entre as partes que
                    possam decorrer do contrato celebrado na sequência de
                    informação disponibilizada pelo portal Poupa Energia.{' '}
                  </p>
                </div>
                <div className='item bold'>
                  <p> Em caso de dúvida contacte-nos através do 211 160 500 </p>
                </div>
              </ListRow>

              <Row noPadding>
                <GhostRadioV2
                  type='checkbox'
                  name='allow_data_sharing'
                  labelStyles={{ flex: '1' }}
                  label={
                    <TermsLink>
                      Concordo com os{' '}
                      <a
                        target='_blank'
                        href={`${PAGE_URL}/termos-e-condicoes/`}>
                        termos e condições
                      </a>{' '}
                      e autorizo o envio desta informação para o
                      comercializador.
                    </TermsLink>
                  }
                  selected={allowDataSharing.value}
                  onClick={() =>
                    changeField(
                      'confirm',
                      'allowDataSharing',
                      !allowDataSharing.value
                    )
                  }
                />
              </Row>
            </tbody>
          </Table>
        </div>
        {renderBtns()}
      </Wrapper>
    )
  )
}

export default Revision

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  align-self: stretch;
  flex-grow: 1;

  > .tableWrapper {
    overflow-y: auto;
    display: flex;
    align-self: stretch;
    flex: 1 0 0;
  }
`

const Table = styled.table`
  width: 100%;
  border-spacing: 0;
`

const Row = styled.tr`
  display: flex;
  padding: ${({ hasImg }) => (hasImg ? '8px 16px' : '10px 16px')};
  align-items: ${({ isEnergy }) => (isEnergy ? 'flex-start' : 'center')};
  gap: 4px;
  flex: 1 0 0;
  border-bottom: 1px solid #ececec;

  ${({ noPadding }) =>
    noPadding &&
    `
    padding: 0;
  `}
`

const ListRow = styled.tr`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  padding: 10px 16px;

  > .item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }

  > .item svg {
    width: 18px;
    height: 18px;

    path {
      fill: #006736;
    }
  }

  > .item p {
    flex: 1 0 0;
    color: #3e3e3e;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
  }

  .item.bold p {
    font-weight: 700;
  }
`

const TermsLink = styled.p`
  color: #1d1e22;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin: 0;

  > a {
    color: #1d1e22;
    text-decoration-line: underline;
  }
`

const TitleCell = styled.td`
  color: #006736;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
`

const InvoiceCell = styled.td`
  flex: 1 0 0;
  display: flex;
  align-items: center;
  gap: 4px;

  color: #3e3e3e;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: ${({ light }) => (light ? '400' : '600')};
  line-height: 20px;

  > img {
    width: 50px;
    height: 26px;
    object-fit: contain;
  }
`

const EnergyCell = styled.td`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;

  > span {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }

  > span p {
    color: #1d1e22;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/JoinTariffModalV2/mobileComponents/revision.js